import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.ends-with.js";
import { describeImageSizeTypeEnum } from "@/apis/model/describeImageSizeTypeEnum";
export function p(o) {
  // tslint:disable-next-line: no-null-keyword no-magic-numbers
  return JSON.stringify(o, null, 2);
}
export function assertNever(x, msg) {
  throw new Error(msg || "x is not never");
}
export function getOriginalImage(imageUrl) {
  if (!imageUrl.includes("@")) return imageUrl;
  return imageUrl.split("@")[0];
}
export function formatImageUrl(imageUrl, size) {
  if (imageUrl.includes("@!")) {
    imageUrl = imageUrl.split("@!")[0];
  }

  return imageUrl + describeImageSizeTypeEnum(size);
}
export function getVideoCover(path) {
  if (path.endsWith(".mp4") || path.endsWith(".flv")) {
    return path + "?x-oss-process=video/snapshot,t_0,f_jpg,w_400,h_300,m_fast";
  }

  return "";
}